import { filterCatalogQuests } from './_filter-quests'
import { Search } from './_search'
import { CatalogList } from './_list'
import { CatalogMap } from './_map'
import { Sort } from '../../../shared/sort/sort'
import { CatalogFilters } from './_filters'
import { initCatalogViewSwitch } from './_switch'

/**
 * Инициализирует каталог квестов со всеми его компонентами:
 * список, карта, фильтры, поиск и сортировка
 */
export function initCatalog() {
  const catalogElement = document.querySelector<HTMLElement>(
    '[data-quests-catalog]'
  )

  if (!catalogElement) return

  const questsData = JSON.parse(
    document.getElementById('quests-data')?.textContent || '[]'
  )
  const pageSize = Number(catalogElement.dataset.pageSize)

  if (!Number.isInteger(pageSize) || pageSize <= 0) {
    console.warn('Catalog page size is missing or invalid')
    return
  }

  const listContainer = document.querySelector(
    '[data-catalog-list]'
  ) as HTMLElement

  if (!listContainer) {
    console.warn('Catalog list container not found')
    return
  }

  const filterEl = catalogElement.querySelector<HTMLElement>(
    '[data-catalog-filters]'
  )

  const mapContainer = document.querySelector(
    '[data-quests-map]'
  ) as HTMLElement

  if (!mapContainer) {
    console.warn('Catalog map container not found')
    return
  }

  const map = new CatalogMap(mapContainer, questsData)

  const list = new CatalogList(listContainer, questsData, pageSize, (quests) =>
    map.updateQuests(quests)
  )

  const categories = getCategoriesFromDropdown(filterEl)

  new CatalogFilters({
    element: filterEl || catalogElement,
    categories,
    typeOptions: [],
    onChange: list.getFiltersChangeHandler()
  })

  const searchEl = catalogElement.querySelector<HTMLElement>('[data-search]')

  if (searchEl) {
    new Search({
      element: searchEl!,
      placeholder: searchEl?.getAttribute('data-search-placeholder') || '',
      onChange: list.getSearchChangeHandler()
    })
  }

  const sortEl = catalogElement.querySelector<HTMLElement>(
    '[data-catalog-sort]'
  )

  new Sort({
    element: sortEl!,
    value: sortEl?.getAttribute('data-catalog-sort-value') || '',
    onChange: list.getSortChangeHandler()
  })

  initCatalogViewSwitch({ catalogElement, map })
}

/**
 * Инициализирует отдельную страницу карты квестов, используя тот же компонент карты,
 * что и переключатель вида в каталоге
 */
export function initQuestsMapPage() {
  const pageElement = document.querySelector<HTMLElement>(
    '[data-quests-map-page]'
  )

  if (!pageElement) return

  const mapContainer = document.querySelector<HTMLElement>('[data-quests-map]')

  if (!mapContainer) {
    console.warn('Catalog map container not found')
    return
  }

  const questsData = JSON.parse(
    document.getElementById('quests-data')?.textContent || '[]'
  )

  const map = new CatalogMap(mapContainer, questsData)
  const filterEl = pageElement.querySelector<HTMLElement>(
    '[data-catalog-filters]'
  )
  new CatalogFilters({
    element: filterEl || pageElement,
    categories: getCategoriesFromDropdown(filterEl),
    typeOptions: [],
    onChange: (filters) =>
      map.updateQuests(filterCatalogQuests(questsData, filters))
  })
  map.show()
}

/**
 * Извлекает список категорий из выпадающего списка фильтров
 * @param {HTMLElement | null} filterEl - Элемент фильтра
 * @return {Array<{label: string, value: string}>} Массив объектов с меткой и значением категории
 */
function getCategoriesFromDropdown(filterEl: HTMLElement | null): Array<{
  label: string
  value: string
}> {
  if (!filterEl) return []

  const options = filterEl.querySelectorAll<HTMLElement>(
    '[data-catalog-filter="categories"] [data-dropdown-option]'
  )

  return Array.from(options)
    .map((option) => {
      const label = option.dataset.dropdownLabel?.trim()
      const value = option.dataset.dropdownValue?.trim()
      if (!label || !value) return null

      return { label, value }
    })
    .filter((option): option is { label: string; value: string } =>
      Boolean(option)
    )
}
